<template>
  <div class="c-map-item-route">
    <!-- Троллейбус или трамвай -->
    <template v-if="item.geozone && item.geozone.type == 'polygone'">
      <l-polygon
        :lat-lngs="item.geozone.geopoints"
        :color="color || item.color"
        :fillColor="color || item.color"
        :fillOpacity="0.95"
        :weight="2"
      >
      </l-polygon>
    </template>
    <!-- Троллейбус или трамвай END -->

    <!-- Автобус -->
    <template v-if="item.geozone && item.geozone.type == 'line'">
      <!-- Прямо и Обратно -->
      <l-polyline
        :lat-lngs="[
          ...item.geozone.geopoints.forward,
          ...item.geozone.geopoints.backward
        ]"
        :color="color || item.color"
        :weight="polyline_weight"
      >
      </l-polyline>
      <!-- Прямо и Обратно END -->
    </template>
    <!-- Автобус END -->
  </div>
</template>

<script>
import * as Vue2Leaflet from 'vue2-leaflet'
export default {
  name: 'c-map-item-route',
  components: {
    'l-polyline': Vue2Leaflet.LPolyline,
    'l-polygon': Vue2Leaflet.LPolygon,
  },
  props: {
    item: {
      type: Object,
      default() {
        return {}
      }
    },
    color: {
      type: [String, Number],
      default: null
    },
    polyline_weight: {
      type: [String, Number],
      default: 5
    },
  }
}
</script>